module.exports = __webpack_public_path__ + "img/White-thankyou.12427aa2.png";